import { render, staticRenderFns } from "./ModalAssignKanban.vue?vue&type=template&id=67a133d2&"
import script from "./ModalAssignKanban.vue?vue&type=script&lang=js&"
export * from "./ModalAssignKanban.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports